import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

function setupResourceHintsAndPrefetch() {
  try {
    const hints: Array<{ rel: string; href: string; crossOrigin?: string }> = [];

    const apiBase = process.env.REACT_APP_API_URL || '';
    if (apiBase) {
      const apiOrigin = new URL(apiBase).origin;
      hints.push({ rel: 'dns-prefetch', href: apiOrigin });
      hints.push({ rel: 'preconnect', href: apiOrigin, crossOrigin: 'anonymous' });
    }

    hints.push({ rel: 'dns-prefetch', href: 'https://pay.easebuzz.in' });
    hints.push({ rel: 'preconnect', href: 'https://pay.easebuzz.in', crossOrigin: 'anonymous' });

    const head = document.head;
    for (const h of hints) {
      const id = `hint:${h.rel}:${h.href}`;
      if (document.getElementById(id)) continue;
      const link = document.createElement('link');
      link.id = id;
      link.rel = h.rel;
      link.href = h.href;
      if (h.crossOrigin) link.crossOrigin = h.crossOrigin;
      head.appendChild(link);
    }

    const nav: any = (navigator as any);
    const conn = nav?.connection;
    const saveData = !!conn?.saveData;
    const effectiveType = String(conn?.effectiveType || '');
    const isSlow = saveData || effectiveType.includes('2g');

    if (!isSlow) {
      const idle = (cb: () => void) => {
        const w: any = window as any;
        if (typeof w.requestIdleCallback === 'function') return w.requestIdleCallback(cb, { timeout: 2000 });
        return window.setTimeout(cb, 600);
      };

      idle(() => {
        import('./pages/Projects/ProjectsList');
        import('./pages/Dashboard');
      });
    }
  } catch {
  }
}

function setupChunkLoadRecovery() {
  const shouldReload = (message: string) => {
    const m = (message || '').toLowerCase();
    return (
      m.includes('chunkloaderror') ||
      (m.includes('loading chunk') && m.includes('failed')) ||
      (m.includes('failed to fetch dynamically imported module'))
    );
  };

  const reloadOnce = () => {
    try {
      const key = 'chunk_reloaded_once';
      if (sessionStorage.getItem(key) === '1') return;
      sessionStorage.setItem(key, '1');

      const url = new URL(window.location.href);
      url.searchParams.set('__reload', String(Date.now()));
      window.location.href = url.toString();
    } catch (_) {
      window.location.reload();
    }
  };

  window.addEventListener('error', (event) => {
    const msg = (event as any)?.message || '';
    if (shouldReload(String(msg))) reloadOnce();
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason: any = (event as any)?.reason;
    const msg = reason?.message || String(reason || '');
    if (shouldReload(String(msg))) reloadOnce();
  });
}

setupChunkLoadRecovery();
setupResourceHintsAndPrefetch();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
